import React from 'react';

// Components
import SearchProduct from '../../../../components/searchProducts';
import useCart from '../../../../hooks/orders/CartProvider';

import useUser from '../../../../hooks/user/useUser';
import { ShippingTypes } from '../../../../models/ShippingTypes';

const Catalogs = () => {
    const { branch } = useUser();
    const { 
        sale: {
            items,
            returnMode,
            itemsToReturn,
            shippingData
        }, 
        update, 
        clearShippingData 
    } = useCart();

    const getKeyNameItems = () => returnMode ? 'itemsToReturn' : 'items';
    const getItems = () => (returnMode ? itemsToReturn : items) ?? [];

    const validateShippingdata = ( items ) => {
        if (items.length <= 0)
            return;
        
        const needDelivery = items.some(i => i.warehouseId !== branch.warehouseId)
        if (!needDelivery)
            return;
        
        if(!shippingData || shippingData.type === ShippingTypes.Delivery)
            return;

        clearShippingData();
    }

    const handleOnAddProduct = (newItem, priceListId) => {
        const key = getKeyNameItems();
        let items = getItems();

        newItem.warehouseId = returnMode 
            ? branch.warehouseId 
            : newItem.warehouseId;
            
        items = !items.some(item => item.refId === newItem.refId && item.warehouseId === newItem.warehouseId)
            ? [...items, newItem]
            : items
                .map(item => {
                    if(item.refId !== newItem.refId || item.warehouseId !== newItem.warehouseId)
                        return item;

                    return {
                        ...item,
                        quantity: item.quantity + newItem.quantity
                    }
                });

        const isClear = newItem.warehouseId !== branch.warehouseId;
        if(!returnMode && !isClear)
            validateShippingdata( items );

        update({ [key]: items, priceListId, shippingData: !isClear ? shippingData : null });
    }

    const handleOnSave = (products, priceListId) => {
        const key = getKeyNameItems();
        const items = getItems();

        const newRefIds = items
            .map(product => {
                const item = products
                    .find(item => item.refId === product.refId);

                if (!item)
                    return product;

                return {
                    ...product,
                    quantity: product.quantity + item.quantity,
                    warehouseId: returnMode 
                        ? branch.warehouseId 
                        : item.warehouseId,
                }
            })
            .concat(products.filter(product =>
                !items.some(item => item.refId === product.refId)))
            .map(product => ({
                masterProductId: product.masterProductId,
                productId: product.productId,
                refId: product.refId,
                quantity: product.quantity,
                warehouseId: product.warehouseId ?? branch.warehouseId,
            }));

        update({ [key]: newRefIds, priceListId });
    }

    const handleOnRemoveProduct = (newItem, priceListId) => {
        const key = getKeyNameItems();
        let items = getItems();

        if(items.some(item => item.refId === newItem.refId)) {
            items = items
                .map(item => {
                    if(item.refId !== newItem.refId)
                        return item;

                    return {
                        ...item,
                        quantity: item.quantity - newItem.quantity,
                        warehouseId: returnMode 
                            ? branch.warehouseId 
                            : item.warehouseId,
                    }
                })
                .filter(item => item.quantity > 0);

            update({ [key]: items, priceListId });
        }
    }

    return (
        <SearchProduct 
            shoppingMode
            onAddItem={handleOnAddProduct}
            onRemoveItem={handleOnRemoveProduct}
            onSetItems={handleOnSave}
        />
    )
}

export default Catalogs;